
import { defineComponent } from 'vue';
import HeroPrincipal from '@/components/HeroPrincipal.vue';
import FaixaNumeros from '@/components/FaixaNumeros.vue';
import ContatoIndex from '../Contato/ContatoIndex.vue';
import CaixaServico from '@/components/CaixaServico.vue';
import ChamadaOrcamento from '@/components/ChamadaOrcamento.vue';
import SobreEmpresa from '@/components/SobreEmpresa.vue';
import CaixaCliente from '@/components/CaixaCliente.vue';
import AvaliacoesGoogle from '@/components/AvaliacoesGoogle.vue';
import SimuladorSolar from '@/components/SimuladorSolar.vue';
import { conteudoSite, urlDaImagem } from '@/uteis/conteudo';

export default defineComponent({
  name: 'HomeIndex',
  components:{
    HeroPrincipal,
    FaixaNumeros,
    ContatoIndex,
    CaixaServico,
    ChamadaOrcamento,
    SobreEmpresa,
    CaixaCliente,
    AvaliacoesGoogle,
    SimuladorSolar
},
  data() {
    return {
      conteudo: conteudoSite,
      // ilustrações fixas dos cartões de serviço, por posição
      imagensServicos: [
        'servicos/orcamento.svg',
        'servicos/projetos.svg',
        'servicos/execucao.svg',
        'servicos/automacao.svg',
        'servicos/solar.svg',
        'servicos/startup.svg'
      ]
    };
  },
  methods: {
    urlDaImagem
  }
});

